import { render, staticRenderFns } from "./DocumentPortalSetupChecklistView.vue?vue&type=template&id=23b606e4&scoped=true&"
import script from "./DocumentPortalSetupChecklistView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSetupChecklistView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalSetupChecklistView.vue?vue&type=style&index=0&id=23b606e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b606e4",
  null
  
)

export default component.exports